import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

const FindAFriend = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Container maxW="container.sm" py={10}>
      <Box
        bg={bgColor}
        p={6}
        borderRadius="md"
        boxShadow="md"
        border="1px"
        borderColor={borderColor}
      >
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading size="lg" color="mamaFuel.moss.700">
              Find a Friend's MommaFuel
            </Heading>
          </Box>
          
            <Text fontWeight="bold" fontSize="lg">
              Privacy Protection
            </Text>
            <Text fontSize="md">
              For privacy reasons, you need to be given the direct link to a friend's MommaFuel by the owner. 
              We don't allow searching for other people's MommaFuels.
            </Text>

          <Box textAlign="center" >
            <VStack spacing={3}>
              <Link to="/login">
                <Button 
                  bg="mamaFuel.moss.700"
                  color="white"
                  _hover={{ bg: "mamaFuel.moss.600" }}
                >
                  Looking for Your Own MommaFuel?
                </Button>
              </Link>
              <Link to="/">
                <Button variant="outline" colorScheme="blue">
                  Return Home
                </Button>
              </Link>
            </VStack>
          </Box>
        </VStack>
      </Box>
    </Container>
  );
};

export default FindAFriend;